<div role="status" [attr.aria-label]="'DISCUSSIONS.LOADING' | translate">
  <span class="sr-only">{{ "DISCUSSIONS.LOADING" | translate }}</span>
  <div
    aria-hidden="true"
    class="space-y-2 animate-pulse motion-reduce:animate-none"
  >
    @for (row of [0, 1, 2]; track row) {
    <div class="flex items-center gap-1.5">
      <span
        class="block h-4 w-4 shrink-0 rounded-full bg-black/5 dark:bg-white/5"
      ></span>
      <div class="flex-1 space-y-1">
        <span
          class="block h-1.5 w-1/3 rounded-full bg-black/5 dark:bg-white/5"
        ></span>
        <span
          class="block h-1.5 w-3/4 rounded-full bg-black/5 dark:bg-white/5"
        ></span>
      </div>
    </div>
    }
  </div>
</div>
